import type { ThemeV2 } from '$lib/types/Theme';

export const isFunBrandsEnabled = (data: { themeV2: ThemeV2 }): boolean => {
    return !!data.themeV2?.accent;
};
